import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Form, Field } from 'formik'
import { useModal } from 'react-modal-hook'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Loading from 'custom/assets/loaders/Loading'
import DashboardService from '../../services/dashboard.service'
import NeoInput from '../../components/NeoInput/NeoInput'
import InputError from '../../components/InputError/InputError'
import Modal from '../../components/Modal/Modal'
import { OtherPaymentsSchema } from '../../schemas/other-payments'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import NeoButton from '../../components/NeoButton/NeoButton'
import NumberFormat from 'react-number-format'
import { carouselCurrentItemSelector, carouselItemsSelector } from '../../selectors'
import ComingSoon from 'custom/assets/common-icons/comingSoon.svg'
import LayoutWithAccountCard from '../../layout/Layout/layout-account-card'
import AccountDisplay from '../../components/account-display/account-display'
import TermsAndConditions from '../../components/TermsAndConditions/TermsAndCondition'
import { setAccRefresh } from '../../actions'

export default function OtherPayments() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(0)
  const [otpEnable, setOtpEnable] = useState('')
  const [otp, setOtp] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [otherPaymentList, setOtherPaymentList] = useState([])
  const [formData, setFormData] = useState({
    otherBillPaymentId: '',
    serviceNumber: '',
    amount: '',
    remarks: '',
    destAccount: '',
    destAccBranch: '',
    destAccCcy: '',
    institutionName: '',
  })
  const [message, setMessage] = useState('')
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const [isVerified, setIsVerified] = useState(false)
  const [utilityDetails, setUtilityDetails] = useState({})

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{message?.code || 'JS Error'} </b> : {message?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={'OK'}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )

  const getUtilityDetails = useCallback(async (otherBillPaymentId, serviceNumber) => {
    try {
      setIsVerified(false)
      if (otherBillPaymentId?.length === 0) {
        setMessage({ code: 'Js Error', message: 'Please Select Utility Name' })
        showModal()
        return
      }
      setLoading(true)
      const response = await DashboardService.getAllUtilityStudentsName({
        institutionId: otherBillPaymentId,
        id: serviceNumber,
      })
      if (
        response.status === 200 &&
        response.data.status !== '400' &&
        response.data.status !== 'null'
      ) {
        setUtilityDetails(response.data)
        setLoading(false)
        setIsVerified(true)
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const getAllOtherPaymentsList = useCallback(async () => {
    const response = await DashboardService.getAllUtilityPayments('OTHERS')
    if (response.status === 200) {
      setOtherPaymentList(response.data['utilitiesList'])
      setStage(1)
    }
  })

  const handleOtherBillPaymentVerify = useCallback(
    async (formData) => {
      try {
        if (!isVerified) {
          setMessage({ code: 'INVALID', message: 'Customer Does not Exist' })
          showModal()
          return
        }
        const instituteDetails = otherPaymentList.filter(
          (ele) => ele?.institutionID === formData.otherBillPaymentId,
        )[0]
        formData.remarks = formData.remarks
        formData.institutionName = instituteDetails?.institutionName
        formData.institutionID = instituteDetails?.institutionID
        formData.customer_name = utilityDetails.customer_name
        formData.destAccount = instituteDetails.accountNumber
        formData.destAccBranch = instituteDetails.accountBranch
        formData.address = utilityDetails.address
        setFormData(formData)
        const response = await DashboardService.otherUtilityPaymentVerify(
          formData,
          currentAccountDetail,
        )
        if (response.status === 200) {
          setOtpEnable(response.data['otpEnable'])
          setStage(2)
        }
      } catch (err) {
        setLoading(false)
        setStage(1)
      }
    },
    [utilityDetails, currentAccountDetail, isVerified],
  )

  const handleOtherBillPaymentConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const reqParams = {
        ...formData,
        otp: otp,
      }
      const response = await DashboardService.otherUtilityPaymentConfirm(
        reqParams,
        currentAccountDetail,
      )
      if (response.status === 200) {
        setStage(4)
        dispatch(setAccRefresh(true))
        setSuccessMessage(response.data.message)
        setLoading(false)
      }
    } catch (err) {
      setOtp('')
      setLoading(false)
    }
  }, [formData, otp, currentAccountDetail])

  useEffect(() => {
    getAllOtherPaymentsList()
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        renderLoading()
      //return renderNoData()
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return (
          <NeoOTP
            otp={otp}
            setOTP={setOtp}
            onSubmit={handleOtherBillPaymentConfirm}
            loading={loading}
          />
        )
      case 4:
        return <NeoSuccess message={successMessage} linkPath='/payments' />
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderNoData() {
    return (
      <div>
        <p className='coming-soon-text'>
          Coming Soon. Please visit your nearest branch for assistance.
        </p>
        <img src={ComingSoon} width={350} style={{ margin: '0 auto', display: 'block' }} />
      </div>
    )
  }

  function renderForm() {
    return (
      <div>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <Formik
          initialValues={formData}
          validationSchema={OtherPaymentsSchema}
          onSubmit={handleOtherBillPaymentVerify}>
          {({ isSubmitting, errors, values, touched, setFieldValue, handleChange, disabled }) => (
            <Form>
              <div className='row'>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='control-label'>Utility Name *</label>
                    <Field
                      as='select'
                      className='form-control'
                      name='otherBillPaymentId'
                      value={values.otherBillPaymentId}
                      onChange={(e) => {
                        handleChange(e)
                        setFieldValue('serviceNumber', '')
                      }}>
                      <option disabled value='' />
                      {otherPaymentList.map((acc, i) => (
                        <option key={i} value={acc?.institutionID}>
                          {acc?.institutionName}
                        </option>
                      ))}
                    </Field>
                    <InputError
                      text={errors.otherBillPaymentId}
                      touched={touched.otherBillPaymentId}
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='control-label'>Customer ID *</label>
                    <Field
                      as='input'
                      type='text'
                      className='form-control'
                      name='serviceNumber'
                      value={values.serviceNumber}
                      onChange={handleChange}
                      onBlur={() => {
                        if (values.serviceNumber.length > 0) {
                          getUtilityDetails(values.otherBillPaymentId, values.serviceNumber)
                        }
                      }}
                    />
                    <InputError text={errors.serviceNumber} touched={touched.serviceNumber} />
                  </div>
                </div>
                {loading ? (
                  <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
                    <Loading width='30px' height='30px' />
                  </div>
                ) : isVerified && utilityDetails?.status === '200' ? (
                  <div className='col-12'>
                    <div className='form-group row'>
                      <label className='control-label'>
                        <div className='col-12'>
                          Customer Name : <b>{utilityDetails?.customer_name}</b>
                        </div>
                        <br />
                        <div className='col-12'>
                          Address : <b>{utilityDetails?.address}</b>
                        </div>
                      </label>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>

              <div className='row'>
                <div className='col-12'>
                  <div className='form-group'>
                    <NeoInput
                      mode='amount'
                      text='Amount *'
                      onChange={(values) => {
                        setFieldValue('amount', values.value)
                      }}
                      name='amount1'
                    />
                    <InputError text={errors.amount} touched={touched.amount} />
                  </div>
                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='control-label'>Remarks *</label>
                    <Field as='input' type='text' className='form-control' name='remarks'></Field>
                    <InputError text={errors.remarks} touched={touched.remarks} />
                  </div>
                </div>
              </div>

              <div className='mt-3'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton type='submit' disabled={isSubmitting} text='Submit' mode='newDesign' />
                )}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <div className='d-flex flex-column confirmation'>
          <div>
            <h6 className='label'>Utility Name</h6>
            <h6 className='value'>{formData?.institutionName}</h6>
          </div>
          <div>
            <h6 className='label'>Receiver Account No.</h6>
            <h6 className='value'>{formData.destAccount}</h6>
          </div>
          <div>
            <h6 className='label'>Receiver Branch.</h6>
            <h6 className='value'>{formData.destAccBranch}</h6>
          </div>

          <div>
            <h6 className='label'>Customer ID</h6>
            <h6 className='value'>{formData.serviceNumber}</h6>
          </div>
          <div>
            <h6 className='label'>Customer Name</h6>
            <h6 className='value'>{formData?.customer_name}</h6>
          </div>
          <div>
            <h6 className='label'>Address</h6>
            <h6 className='value'>{formData?.address}</h6>
          </div>
          <div>
            <h6 className='label'>Amount</h6>
            <h6 className='value'>
              <NumberFormat
                value={formData.amount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              />
            </h6>
          </div>
          <div>
            <h6 className='label'>Remarks</h6>
            <h6 className='value'>{formData.remarks}</h6>
          </div>
          <div>
            <TermsAndConditions module='BILLPAYMENT' />
          </div>
          <div className='mt-3'>
            {loading ? (
              renderLoading()
            ) : (
              <NeoButton
                mode='newDesign'
                type='button'
                text={'Confirm'}
                onClick={() => (otpEnable ? setStage(3) : handleOtherBillPaymentConfirm())}
              />
            )}
          </div>
          <div className='back-cancel-style' onClick={() => setStage(1)}>
            Back
          </div>
        </div>
      </div>
    )
  }
  return (
    <LayoutWithAccountCard breadCumKey='OTHER_PAYMENT' keyPath={'OTHER_PAYMENT'}>
      <div className='new-design-form-style'>
        <div className='heading-style'>Other Payments</div>
        {renderSwitch()}
      </div>
    </LayoutWithAccountCard>
  )
}
